import { gql } from '@apollo/client'
import { DISPLAY_SEGMENT_FRAGMENT } from './DIsplaySegmentFragment'

export const PLANOGRAM_FRAGMENT = gql`
  fragment Planogram on Planogram {
    id
    numSegments
    name
    fixtureType {
      id
      name
    }
    zone {
      id
      name
    }
    segments {
      ...DisplaySegment
    }
    effectiveDate
  }
  ${DISPLAY_SEGMENT_FRAGMENT}
`
